export default (value: unknown): boolean => {
  if (!value) {
    return false;
  }

  return value instanceof Function;
};
